<template>
  <v-row
    class="code-condition-group"
    align-content-md="center">
    <v-col
      cols="12"
      md="10">
      <validation-provider
        v-slot="{ errors }"
        name="มูลค่าที่ลด"
        :rules="action === 'generateNewCode' ? { required: true, min_value: 0} : {}">
        <v-text-field
          v-model="form.codeValue.value"
          type="number"
          min="0"
          class="ml-2"
          :error-messages="errors[0]"
          label="มูลค่าที่ลด"
          :readonly="!editable"
          @input="bindValue" />
      </validation-provider>
    </v-col>
    <v-col
      cols="12"
      md="10">
      <validation-provider
        v-slot="{ errors }"
        name="ชนิดของการลด"
        :readonly="!editable"
        :rules="action === 'generateNewCode' ? { required: true} : {}">
        <v-select
          v-model="form.discountType.value"
          :items="discountTypes"
          label="ชนิดของการลด"
          class="ml-2"
          :error-messages="errors[0]"
          :readonly="!editable"
          @input="bindValue" />
      </validation-provider>
    </v-col>
    <v-col
      cols="12"
      md="10">
      <v-row class="ml-1">
        <v-checkbox
          v-model="form.minSpending.enable"
          hide-details
          :readonly="!editable"
          @input="bindValue" />
        <validation-provider
          v-slot="{ errors }"
          name="ยอดขั้นต่ำ"
          style="width: 91%"
          :rules="form.minSpending.enable ? 'required||min_value:0' : ''">
          <v-text-field
            v-model="form.minSpending.value"
            :disabled="!form.minSpending.enable"
            type="number"
            min="0"
            label="ยอดขั้นต่ำ"
            :error-messages="errors[0]"
            :readonly="!editable"
            @input="bindValue" />
        </validation-provider>
      </v-row>
    </v-col>
    <v-col
      cols="12"
      md="10">
      <v-row class="ml-1">
        <v-checkbox
          v-model="form.mostDiscount.enable"
          hide-details
          :readonly="!editable"
          @input="bindValue" />
        <validation-provider
          v-slot="{ errors }"
          name="ลดสูงสุด"
          style="width: 91%"
          :rules="form.mostDiscount.enable ? 'required||min_value:0' : ''">
          <v-text-field
            v-model="form.mostDiscount.value"
            :disabled="!form.mostDiscount.enable"
            type="number"
            min="0"
            :error-messages="errors[0]"
            label="ลดสูงสุด"
            :readonly="!editable"
            @input="bindValue" />
        </validation-provider>
      </v-row>
    </v-col>
    <v-col
      cols="12"
      md="10">
      <v-row class="ml-1">
        <v-checkbox
          v-model="form.perUser.enable"
          hide-details
          :readonly="!editable"
          @input="bindValue" />
        <validation-provider
          v-slot="{ errors }"
          name="จำนวนการใช้ต่อคน"
          style="width: 91%"
          :rules="form.perUser.enable ? 'required||min_value:0' : ''">
          <v-text-field
            v-model="form.perUser.value"
            :disabled="!form.perUser.enable"
            type="number"
            min="0"
            :error-messages="errors[0]"
            label="จำนวนการใช้ต่อคน"
            :readonly="!editable"
            @input="bindValue" />
        </validation-provider>
      </v-row>
    </v-col>
    <v-col
      cols="12"
      md="10">
      <v-row class="ml-1">
        <v-checkbox
          v-model="form.rightAmount.enable"
          hide-details
          :readonly="!editable"
          @input="bindValue" />
        <validation-provider
          v-slot="{ errors }"
          name="จำนวนสิทธิ์"
          style="width: 91%"
          :rules="form.rightAmount.enable ? 'required||min_value:0' : ''">
          <v-text-field
            v-model="form.rightAmount.value"
            :disabled="!form.rightAmount.enable"
            min="0"
            type="number"
            :error-messages="errors[0]"
            label="จำนวนสิทธิ์"
            :readonly="!editable"
            @input="bindValue" />
        </validation-provider>
      </v-row>
    </v-col>
    <v-col
      cols="12"
      md="10">
      <v-row class="ml-1">
        <v-checkbox
          v-model="form.categories.enable"
          hide-details
          :readonly="!editable"
          @input="bindValue" />
        <validation-provider
          v-slot="{ errors }"
          name="หมวดหมู่สินค้า"
          style="width: 91%"
          :rules="form.categories.enable ? 'required' : ''">
          <v-combobox
            v-model="form.categories.value"
            :disabled="!form.categories.enable"
            type="text"
            label="หมวดหมู่สินค้า"
            class="categories-combobox-field"
            :error-messages="errors[0]"
            multiple
            small-chips
            deletable-chips
            :readonly="!editable"
            @input="bindValue" />
        </validation-provider>
      </v-row>
    </v-col>
    <v-col
      cols="12"
      md="5">
      <v-row
        class="ml-1">
        <v-checkbox
          v-model="form.minDate.enable"
          hide-details
          @input="bindValue" />
        <validation-provider
          v-slot="{ errors }"
          name="เวลา"
          style="width: 87%"
          :readonly="!editable"
          :rules="form.minDate.enable ? 'required' : ''">
          <date-field
            v-model="form.minDate.value"
            class="ml-2"
            :default="form.minDate.value"
            :disabled="!form.minDate.enable"
            :error-messages="errors[0]"
            label="ตั้งแต่"
            :editable="editable"
            @input="bindValue" />
        </validation-provider>
      </v-row>
    </v-col>
    <v-col
      class="mt-4"
      cols="12"
      md="5">
      <v-row
        class="ml-1">
        <v-checkbox
          v-model="form.maxDate.enable"
          hide-details
          :readonly="!editable"
          @input="bindValue" />
        <validation-provider
          v-slot="{ errors }"
          name="เวลา"
          :rules="form.maxDate.enable ? 'required' : ''">
          <date-field
            v-model="form.maxDate.value"
            class="ml-4"
            :default="form.maxDate.value"
            :disabled="!form.maxDate.enable"
            :error-messages="errors[0]"
            label="ถึง"
            :editable="editable"
            @input="bindValue" />
        </validation-provider>
      </v-row>
    </v-col>
    <v-col
      cols="12"
      md="10"
      class="mb-0 pb-0">
      <v-row class="ml-1 mb-0 pb-0">
        <v-checkbox
          v-model="form.tagControl.enable"
          hide-details
          :readonly="!editable"
          @input="bindValue" />
        <validation-provider
          v-slot="{ errors }"
          name="การแยกแท็ก"
          style="width: 79%"
          :rules="form.tagControl.enable ? 'required' : ''">
          <v-radio-group
            v-model="form.tagControl.value"
            :disabled="!form.tagControl.enable"
            :error-messages="errors[0]"
            :readonly="!editable"
            dense
            row
            @input="bindValue">
            <v-radio
              value="include"
              label="ใช้ได้กับ" />
            <v-radio
              value="exclude"
              label="ใช้ไม่ได้กับ" />
          </v-radio-group>
        </validation-provider>
      </v-row>
    </v-col>
    <v-col
      cols="12"
      md="10"
      class="mt-n5 pt-0">
      <v-row class="ml-1 mt-0 pt-0">
        <validation-provider
          v-slot="{ errors }"
          name="แท็กสินค้า"
          style="width: 97%"
          :rules="form.tagControl.enable ? 'required' : ''">
          <v-combobox
            v-model="form.tagsProduct.value"
            :disabled="!form.tagControl.enable"
            :items="list.tags"
            :error-messages="errors[0]"
            type="text"
            label="แท็กสินค้า"
            class="tags-combobox-field"
            multiple
            small-chips
            deletable-chips
            @input="bindValue" />
        </validation-provider>
      </v-row>
    </v-col>
    <v-col
      cols="12"
      md="10">
      <v-row class="ml-1">
        <v-checkbox
          v-model="form.channel.value"
          value="web"
          label="ใช้ได้กับ online"
          @change="bindValue" />
        <v-checkbox
          v-model="form.channel.value"
          value="pos"
          class="ml-1"
          label="ใช้ได้กับ หน้าร้าน"
          @change="bindValue" />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import DateField from '@/components/form/DateField.vue'
import TagsProvider from '@/resources/TagsProvider'

const tagsService = new TagsProvider()

export default {
  components: {
    DateField
  },
  props: {
    discountTypes: {
      type: Array,
      default: () => []
    },
    oldCode: {
      type: Object,
      default: () => {}
    },
    editable: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      disableHandle: false,
      form: {
        codeValue: {
          value: null,
          enable: true
        },
        discountType: {
          value: null,
          enable: true
        },
        minSpending: {
          value: null,
          enable: false
        },
        mostDiscount: {
          value: null,
          enable: false
        },
        perUser: {
          value: null,
          enable: false
        },
        rightAmount: {
          value: null,
          enable: false
        },
        tagsProduct: {
          value: [],
          enable: true
        },
        categories: {
          value: [],
          enable: false
        },
        tagControl: {
          value: null,
          enable: false
        },
        minDate: {
          value: null,
          enable: false
        },
        maxDate: {
          value: null,
          enable: false
        },
        channel: {
          enable: true,
          value: []
        }
      },
      list: {
        tags: []
      }
    }
  },
  async mounted () {
    this.list.tags = await this.getTags()
    this.initCodeDetail()
  },
  methods: {
    initCodeDetail () {
      delete this.oldCode.code

      if (this.oldCode.categories?.length === 0) {
        delete this.oldCode.categories
      }
      if (this.oldCode.channel?.length === 0) {
        delete this.oldCode.channel
      }
      if (this.oldCode.tagsProduct?.length === 0) {
        delete this.oldCode.tagsProduct
      }
      Object.keys(this.oldCode).forEach(async (key) => {
        this.form[key].value = await this.oldCode[key]
        this.form[key].enable = true
      })

      if (this.form.maxDate?.enable) {
        this.form.maxDate.value = new Date(this.form.maxDate.value).toISOString().substr(0, 10)
      }
      if (this.form.minDate?.enable) {
        this.form.minDate.value = new Date(this.form.minDate.value).toISOString().substr(0, 10)
      }

      this.bindValue()
    },
    async getTags () {
      let result = []
      try {
        const { data } = await tagsService.getAllTags()
        result = data.map((tag) => tag.doc.name)
      } catch (e) {
        console.error('tagOptions', e)
      }

      return result
    },
    bindValue () {
      this.$emit('input', this.form)
    }
  }
}
</script>

<style>
.code-condition-group .col-12 {
  height: 90px;
  align-self: center;
}

.tags-combobox-field .v-input__append-inner {
  display: none;
}

.categories-combobox-field .v-input__append-inner {
  display: none;
}

</style>
